export default __webpack_public_path__ + "static/media/audio_01_olas.f40349e6.mp3";